import ngAnnotate from '../../ngAnnotate.macro';
import template from './admin_answering.html';
import { getPortalAnsweringConfig } from '../../../api/AnsweringSubscriptionController';
import usesLegacyServiceProvider from '../../../utils/usesLegacyAnsweringServiceProvider';

angular.module('bb.admin').component('bbAdminAnswering', {
  controller: AdminAnsweringController,
  controllerAs: 'vm',
  template,
});

ngAnnotate(AdminAnsweringController);

function AdminAnsweringController(
  $rootScope,
  $scope,
  $q,
  AdminService,
  $location,
) {
  const vm = this;
  vm.auth = $rootScope.auth;

  vm.$onInit = () => {
    vm.tab = 'info';
    $q.all([
      AdminService.getAnsweringSettings('0'),
      // Note that BE route for this doesn't use any params or query
      vm.auth.org.answeringServiceOrg
        ? AdminService.getAnsweringOrg(vm.auth.org.answeringServiceOrg)
        : $q.resolve(undefined),
      // only request answering config if there is an onboarding portal
      // TODO: on conversion to react, use gqlClient directly from front end OR consume directly from auth context (may also need to consume answering portal config loading state). Also remove all corresponding route, controller and service methods, and tests for this call (marked deprecated)
      vm.auth.org.onboardingPortalId
        ? getPortalAnsweringConfig(
            vm.auth.org.onboardingPortalId,
            vm.auth.org.id,
          )
        : $q.resolve(undefined),
    ])
      .then(([{ ignoreSettings }, answeringOrg, answeringConfig]) => {
        vm.answeringOrg = answeringOrg;
        vm.ignoreSettings = !!ignoreSettings;

        if (
          answeringConfig?.useLiveAppointmentDesk ||
          answeringConfig?.mlsProductId
        ) {
          if (!featureEnabled('subscriptionHubFeature')) {
            // Original behavior when the Subscription Hub is off
            $location.path('/admin/appointment_desk');
            return;
          }

          // Legacy-provider orgs stay on this page — forwarding them would
          // bounce them back here via AnsweringServiceContext (redirect loop).
          return usesLegacyServiceProvider(answeringConfig, vm.auth.org).then(
            isLegacy => {
              if (!isLegacy) {
                $location.path('/admin/appointment_desk');
                $scope.$apply();
              }
            },
          );
        }
      })
      .finally(() => {
        vm.loaded = true;
      });
  };

  vm.toggleIgnoreSettings = () => {
    vm.toggling = true;
    vm.ignoreSettings = !vm.ignoreSettings;
    $scope.$digest();
    AdminService.toggleIgnoreAnsweringSettings()
      .then(({ ignoreSettings }) => {
        if (ignoreSettings === null) {
          swal({
            type: 'warning',
            title: 'Toggle Ignore Failed',
            text: 'There are currently no saved time settings to ignore.',
          });
        }
        vm.ignoreSettings = !!ignoreSettings;
      })
      .catch(() => {
        vm.ignoreSettings = !vm.ignoreSettings;
      })
      .finally(() => {
        vm.toggling = false;
      });
  };

  vm.onTabChange = tab => event => {
    event.preventDefault();
    vm.tab = tab;
    $scope.$digest();
  };
}
